export enum Feestype {
    
    AdmissionFee = 50,
    DDFund = 100,
    RejoiningFee = 1500
}
